import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CheckReservationChannelStoreEffects } from './effects';
import { checkReservationChannelReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      'checkReservationChannel',
      checkReservationChannelReducer,
    ),
    EffectsModule.forFeature([CheckReservationChannelStoreEffects]),
  ],
})
export class CheckReservationChannelStoreModule {}
